import React from "react";

import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { IListItem, LeftMenu } from "components";

export const Documents: React.FC = () => {
  const { t } = useTranslation();
  const currentLocale = useLocation();
  const navigate = useNavigate();

  const list: Array<IListItem> = [
    {
      title: "Cadastros",
      navigation: [
        {
          menuTitle: "Administração Teste",
          locale: "/administration",
          read: true,
        },
        {
          menuTitle: t("documents.title"),
          locale: "/administration/documents",
          read: true,
        },
        {
          menuTitle: "Origem do procedimento",
          locale: "/dashboard/admin",
          read: true,
        },
        {
          menuTitle: "Participantes",
          locale: "/administration/participantes",
          read: true,
        },
        {
          menuTitle: t("audiences.type"),
          locale: "/dashboard/props",
          read: true,
        },
        // {
        //   menuTitle: "Tipos de participantes",
        //   locale: "/dashboard/props",
        // },
        {
          menuTitle: "Tipos de procedimento",
          locale: "/dashboard/procedureType",
          read: true,
        },
      ],
    },
    {
      title: "Configurações",
      navigation: [
        {
          menuTitle: "Unidades de polícia",
          locale: "/dashboard/props",
          read: true,
        },
        {
          menuTitle: t("documents.title"),
          locale: "/dashboard/props",
          read: true,
        },
        {
          menuTitle: "Origem do procedimento",
          locale: "/dashboard/admin",
          read: true,
        },
        {
          menuTitle: "Participantes",
          locale: "/dashboard/props",
          read: true,
        },
        {
          menuTitle: t("audiences.type"),
          locale: "/dashboard/props",
          read: true,
        },
        // {
        //   menuTitle: "Tipos de participantes",
        //   locale: "/dashboard/props",
        // },
        {
          menuTitle: "Tipos de procedimento",
          locale: "/dashboard/props",
          read: true,
        },
      ],
    },
  ];

  return (
    <LeftMenu
      currentLocale={currentLocale.pathname}
      type="administration"
      menuTitle={t("administration.title")}
      menuList={list}
      navigate={navigate}
    />
  );
};
